import Detailed from "components/recoveries/tenant-groups/controls/detailed"
import DeleteConfirmation from "components/modal/delete-confirmation"

export default {
  Detailed,
  DeleteConfirmation
}
